import { cn } from "@omni/utils/styles";

import { Config } from "@/utils/config.utils";

type Props = {
    icon: string;
    target: string;
};

const getRedirect = (url: string) => {
    return {
        [Config.pages["checkout-login"]]: Config.pages.cart,
        [Config.pages["checkout-account"]]: Config.pages["checkout-login"],
        [Config.pages["checkout-payment"]]: Config.pages["checkout-account"]
    }[url];
};

const SmallHeaderBackButton = ({ icon, target }: Props) => {
    const getLink = (): string => {
        const url = location.origin + location.pathname;

        return getRedirect(url) || target;
    };

    return (
        <div
            className={cn("tw:text-3xl", "tw:hover:cursor-pointer")}
            onClick={() => location.assign(getLink())}
        >
            <i className={cn(`las la-${icon}`)} />
        </div>
    );
};

export { SmallHeaderBackButton };
